export default {
  myBalance: 'Mein Guthaben',
  topUp: 'Aufladen',
  pay: 'Aufladen',
  repayment: 'Rückzahlung',
  balance: 'Guthaben',
  usableBalance: 'Verfügbares Guthaben',
  inputBalance: 'Bitte Betrag eingeben',
  payBalance: 'Aufladebetrag',
  pecenter: 'Persönliches Zentrum',
  lang: 'Sprache',
  cart: 'Warenkorb',
  recipientName: 'Empfänger',
  goRecharge: 'Jetzt aufladen',
  phone: 'Telefon',
  region: 'Region',
  address: 'Genaue Adresse',
  country: 'Land oder Region',
  province: 'Provinz',
  city: 'Stadt',
  postcode: 'Postleitzahl',
  action: 'Operation',
  mobileSettings: 'Mobile Einstellungen',
  name: 'Name',
  debt: 'SCHULDEN',
  add: 'Kreditkarten-Rechnungsadresse hinzufügen',
  addSuccess: 'Erfolgreich hinzugefügt',
  editSuccess: 'Erfolgreich bearbeitet',
  editBtn: 'Bearbeiten',
  edit: 'Kreditkarten-Rechnungsadresse bearbeiten',
  del: 'Löschen',
  setDefault: 'Als Standard festlegen',
  defaultAddress: 'Standardadresse',
  setDefaultAddress: 'Als Standard-Lieferadresse festlegen',
  setSuccess: 'Erfolgreich festgelegt',
  myAddress: 'Meine Adressen',
  addAddress: 'Neue Adresse hinzufügen',
  tradeTime: 'Transaktionszeit',
  type: 'Typ',
  incomeOrExpend: 'Einnahmen/Ausgaben',
  accountBalance: 'Kontostand',
  tradeNo: 'Transaktions-ID',
  remark: 'Bemerkung',
  tag: 'Adress-Tag',
  addBillAddress: 'Kreditkarten-Rechnungsadresse hinzufügen',
  deleteBillAddress: 'Rechnungsadresse löschen',
  editBillAddress: 'Rechnungsadresse bearbeiten',
  mergePay: 'Zusammen bezahlen',
  username: 'Benutzername',
  gender: 'Geschlecht',
  birthday: 'Geburtstag',
  avatar: 'Avatar',
  email: 'E-Mail',
  site: 'Seite',
  myOrder: 'Bestellung',
  sideBar: {
    myAccount: 'Mein Konto',
    addressManage: 'Adressverwaltung',
    myAsset: 'Wallet',
    billAddress: 'Rechnungsadresse',
  },
  addDoorNoTips: 'Bitte fügen Sie Ihrer Lieferadresse die Hausnummer hinzu.',
  holder: {
    receiver: 'Empfänger',
    firstName: 'Vorname',
    name: 'Nachname',
    region: 'Bitte Provinz/Stadt/Bezirk/Straße auswählen',
    address:
      'Bitte geben Sie die genaue Adressinformationen ein, z. B. Straße, Hausnummer, Gemeinde, Gebäudenummer, Einheit usw.',
    phone: 'Telefonnummer, Mobiltelefonnummer muss in einem Feld ausgefüllt werden',
    input: 'bitte eingeben',
    select: 'bitte auswählen',
    tagHolder: 'Max. 120 Zeichen (optional)',
    postCodeNoMatch: 'Die Postleitzahl stimmt nicht mit der Region überein',
    doorNo: 'Hausnummer',
  },
  forget: {
    accountSafe: 'Kontosicherheit',
    setPwd: 'Passwort ändern',
    inputBindEmail: 'Bitte geben Sie Ihre verknüpfte E-Mail-Adresse ein',
    inputVerifyCode: 'Bitte geben Sie den Verifizierungscode ein',
    inputPwd: 'Bitte geben Sie das neue Passwort ein',
  },
  accountInfo: {
    name: 'Konto',
    selfInfo: 'Persönliche Informationen',
    cardBillAddress: 'Kreditkarten-Rechnungsadresse',
    shipAddress: 'Lieferadresse',
    editUser: 'Benutzerinformationen bearbeiten',
    inputCountry: 'Bitte geben Sie Ihr Land ein',
    editEmail: 'E-Mail bearbeiten',
    editEmailHint: '(Nur empfohlen, wenn die E-Mail falsch eingestellt ist oder Probleme aufweist)',
    editEmailHint1:
      'Zu Ihrer Kontosicherheit müssen Sie zuerst die Sicherheitsüberprüfung mit „E-Mail-Verifizierungscode + Login-Passwort“ bestehen.',
    editEmailHint2:
      'Zu Ihrer Kontosicherheit müssen Sie zuerst die Sicherheitsüberprüfung mit „E-Mail-Verifizierungscode“ bestehen.',
    currentEmail: 'Aktuelle E-Mail',
    clickVerify: 'Senden',
    reGet: 'Erneut senden',
    nextStep: 'Nächster Schritt',
    notReGetCode: 'Erneut senden nach',
    logoutAccount: 'Konto abmelden',
    emailNotEmpty: 'E-Mail darf nicht leer sein',
    logoutReason: 'Bitte wählen Sie den Grund für die Abmeldung',
    latelyLogin: 'Letzte Anmeldung',
    moreRecord: 'Weitere Aufzeichnungen',
    visitRecord: 'Besuchsaufzeichnungen',
    visitTime: 'Besuchszeit',
    ipAndDevice: 'IP-Adresse & Gerätetyp',
    editLoginPwdHint:
      'Ein hochsicheres Passwort kann Ihr Konto sicherer machen. Es wird empfohlen, Ihr Passwort regelmäßig zu ändern und ein Passwort festzulegen, das Zahlen und Buchstaben enthält und länger als 6 Stellen ist.',
    editPayPwdHint:
      'Das Passwort, das bei der Zahlung mit dem acbuy-Guthaben erforderlich ist. Legen Sie das Zahlungspasswort fest, um die Zahlungssicherheit zu gewährleisten.',
    editVerifyEmailHint:
      'Um die Sicherheit Ihres Kontos zu gewährleisten, verifizieren Sie bitte Ihre E-Mail-Adresse.',
    payPwd: 'Zahlungspasswort',
    editPayPwd: 'Zahlungspasswort ändern',
    setPayPwd: 'Zahlungspasswort festlegen',
    deleteAccount: 'Konto löschen',
  },
  logoutReasonEnum: {
    0: 'Sicherheits-/Datenschutzbedenken',
    1: 'Schlechter Kundenservice',
    2: 'Zu hohe Kosten',
    3: 'Komplizierter Einkaufsprozess',
    4: 'Andere Gründe',
  },
  tradeTypeEnum: {
    0: 'Einnahmen',
    1: 'Ausgaben',
  },
  asset: {
    currentBalance: 'Aktuelles Guthaben',
    canWithdrawBalance: 'Auszahlbarer Betrag',
    withdraw: 'Auszahlen',
    serialNo: 'Seriennummer',
    amount: 'Betrag',
    lossAmount: 'Ausgegebener Betrag',
    withdrawAmount: 'Auszahlungsbetrag',
    inputWithdrawAmount: 'Bitte Auszahlungsbetrag eingeben',
    withdrawSuccess: 'Wypłata została wysłana, przetwarzanie może potrwać do 72 godzin.',
    transactionDate: 'Transaktionsdatum',
    withdrawMethod: 'Auszahlungsmethode',
    availableAmount: 'Verfügbarer Betrag',
    transactionNo: 'Transaktionsnummer',
    withdrawMsg:
      'Hinweis: Die Guthabenauszahlung erfolgt über den ursprünglichen Kanal. Das Guthaben wird dem Zahlungskonto der Auszahlungstransaktion gemäß dem historischen Ausgabennachweis zurückerstattet.',
    transactionRecordsText: 'Verfügbare Guthaben-Transaktionsaufzeichnungen',
    withdrawRecordText: 'Auszahlungsaufzeichnungen',
  },
  package: {
    packageInfo: 'Paketinformationen',
    weightHaveUnit: 'Gewicht (g)',
    sizeHaveUnit: 'Größe (cm)',
    freight: 'Fracht',
    fee: 'Gebühr',
    transportMode: 'Versandart',
    allPackage: 'Alle Pakete',
    myPackage: 'Paket',
  },
  packageStatusEnum: {
    0: 'Ausstehende Gelder',
    1: 'Unbezahlt',
    2: 'In Transit',
    3: 'Abgeschlossen',
    4: 'Storniert',
  },
  storage: {
    name: 'Lager',
    warehouseTime: 'Einlagerungszeit',
    submitTransport: 'Zur Lieferung einreichen',
    lineCanUse: 'Verfügbare Stückzahl',
    commonImg: 'Qualitätskontrollfotos',
    customPhoto: 'angepasst Fotos',
    extendCare: 'Lagerfrist verlängern',
    extendHint:
      'Die Lagerfrist Ihrer Waren im Lager wird um (30 * N) Tage verlängert. Das neue Ablaufdatum ist',
    packMode: 'Verpackungsmethode',
    retainPack: 'Verpackung beibehalten',
    normalPack: 'Standardverpackung',
    normalPackHint: 'Artikel werden in ihrer Originalverpackung verpackt.',
    foldPack: 'Gefaltete Verpackung',
    foldPackHint:
      'Bei nicht verklebten Kartons demontiert das Lager diese, faltet sie flach zusammen und legt sie in das Paket des Nutzers, wodurch das Paketvolumen etwas reduziert werden kann. Es gibt aber auch Fälle, in denen das Paketvolumen zunimmt (wenn weniger Waren vorhanden sind, können sich die Faltlänge und -breite des Kartons vergrößern).',
    discardPack: 'Verpackung entsorgen',
    discardPackHint:
      'Nachdem die Verpackung entsorgt wurde, akzeptiert der Verkäufer möglicherweise keine After-Sales-Leistungen mehr, und das Paket kann nicht mehr gefunden/hinzugefügt werden.',
    photoTemplate: 'Foto-Vorlage',
  },
  operate: 'Operation',
  editAddress: 'Adresse bearbeiten',
  underPaid: 'Unbezahlt',
  goTopay: 'Bezahlen',
  viewRecord: 'Aufzeichnung anzeigen',
  faq: 'FAQ',
  question1: 'F: Wird mein Konto gesperrt, wenn ich eine Auszahlung beantrage?',
  response1:
    'A: Nach Beantragung einer Auszahlung wird der Betrag des Antrags auf dem Konto eingefroren, um sicherzustellen, dass der Rückerstattungsbetrag mit dem von Ihnen beantragten Betrag übereinstimmt.',
  question2:
    'F: Bedeutet „Abgeschlossen“ in den Auszahlungsaufzeichnungen, dass die Auszahlung des Geldes erfolgreich war?',
  response2:
    'A: „Abgeschlossen“ bedeutet, dass acbuy eine Rückerstattung veranlasst hat. Die Zeit, bis das Geld auf Ihrem ursprünglichen Konto eintrifft, hängt jedoch von der Bearbeitungszeit der Drittanbieterplattform ab.',
  question3: 'F: Basiert die Auszahlung auf dem Echtzeit-Wechselkurs?',
  response3:
    'A: Nein, der Auszahlungswechselkurs basiert auf dem Zeitpunkt, zu dem das Guthaben aufgeladen wurde.',
  question4: 'F: Wie zahlen Sie aus, wenn der Kontostand vom Auszahlungsbetrag abweicht?',
  response4:
    'A: Wenn der Kontostand höher ist als der Auszahlungsbetrag, können Sie die Auszahlung in mehreren Schritten beantragen, bis der Kontostand 0 beträgt. Wenn der Kontostand niedriger ist als der Auszahlungsbetrag, können Sie eine einmalige vollständige Auszahlung beantragen.',
  stillRecharge: 'Nicht genug Guthaben für die Bestellung, bitte aufladen',
  amountDue: 'Fälliger Betrag',
  handingFee: 'Bearbeitungsgebühr',
  coupon: 'Gutschein',
  couponPlaceholder: 'Gutscheine mit Gutscheincodes einlösen',
  off: 'Rabatt',
  minFee: 'Mindestgebühr',
  freightText: 'Fracht',
  limitTo: 'Begrenzt auf',
  shippingUsage: 'Versandnutzung',
  availableWarehouse: 'Verfügbares Lager',
  shippingFeeText: 'Versandkosten (ohne Zollabfertigungsgebühr)',
  internationalParcel: 'Internationales Paket',
  to: 'nach',
  availableCoupons: 'Verfügbare Gutscheine',
  usedCoupons: 'Verwendete Gutscheine',
  expiredCoupons: 'Abgelaufene Gutscheine',
  exchangeSuccess: 'Erfolgreich umgetauscht!',
  myAffiliate: {
    name: 'Affiliate',
  },
  affiliateShare: 'Teilen',
  copyText: 'Kopieren',
  affiliateShareMsg:
    'Versandzahlungen, die über geteilte Links erfolgen, generieren Provisionseinnahmen für Sie.',
  businessType: 'Geschäftsart',
  payWay: 'Transaktionstyp',
  bzOrderNo: 'AC-Nr.',
  amountDueTooltip:
    'Aufgrund von Umrechnungsberechnungen des Wechselkurses kann es zu einer Differenz von ca. 0,01 oder 0,02 kommen.',
  balanceStatement: 'Kontoauszug',
  billFlow: 'Rechnung',
  affiliateFavorite: 'Favorit',
  favourite: 'Favorit',
  canUseCountry: 'Verfügbares Land',
  commonNo: 'Nr.',
  question5: 'F: Wie lange dauert es, bis die Abhebung auf meiner Karte eingeht?',
  response5:
    'A: Die Bearbeitungszeit für Auszahlungen kann je nach Zahlungsmethode und Bank variieren und beträgt in der Regel 2 bis 25 Tage. Normalerweise werden Auszahlungen innerhalb von 48 Stunden auf Ihre ursprüngliche Zahlungs- oder Auflademethode zurückgebucht. Sollten Sie die Auszahlung nicht innerhalb von 48 Stunden erhalten, können Sie sich an den Kundenservice wenden, um den aktuellen Status Ihrer Auszahlung zu überprüfen.',
}
